<template>
  <div class="asc-sort-box-chart-button--container">
    <v-row justify="end" no-gutters>
      <v-menu
        min-width="250px"
        bottom
        offset-y
        left
        content-class="asc-sort-box-chart-button--menu-list"
      >
        <template #activator="{ on, attrs }">
          <div
            class="asc-accent-button-container asc-accent-button-container--secondary asc-sort-box-chart-button asc-sort-box-chart-button-accent"
          >
            <v-btn
              v-bind="attrs"
              text
              outlined
              tile
              :ripple="{
                center: true,
                class: 'ripple--secondary',
              }"
              v-on="on"
            >
              {{ sortButtonText }}
            </v-btn>
          </div>
        </template>

        <v-card>
          <v-list>
            <v-list-item
              v-for="item in orderBySelector"
              :key="item.title"
              class="asc-sort-box-chart-button--list-tile"
            >
              <v-list-item-title class="asc-sort-caption">
                {{ item.text }}
              </v-list-item-title>
              <v-list-item-action class="asc-sort-action justify-end">
                <span>
                  <v-icon
                    class="asc-ascending-sort"
                    :size="22"
                    @click="handleSort(item, true)"
                  >
                    mdi-sort-ascending
                  </v-icon>
                  <v-icon
                    class="asc-descending-sort"
                    :size="22"
                    @click="handleSort(item, false)"
                  >
                    mdi-sort-descending
                  </v-icon>
                </span>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'AscSortBoxChartButton',
  components: {},

  props: {
    sort: {
      type: Object,
      required: true,
    },
    onSort: {
      type: Function,
      required: true,
    },
  },

  data() {
    return {
      sortItem: this.sort,
      orderBySelector: [
        { text: 'Min', key: 'min' },
        { text: '1st Quart', key: 'pct25' },
        { text: 'Med', key: 'pct50' },
        { text: '3rd Quart', key: 'pct75' },
        { text: 'Max', key: 'max' },
        { text: 'Alpha', key: 'tail' },
      ],
    }
  },

  computed: {
    sortButtonText() {
      if (this.sortItem && this.sortItem.sortFieldName) {
        return `${this.sortItem.sortFieldName} - ${
          this.sortItem.sortAsc ? 'Asc' : 'Desc'
        }`
      }
      return 'Sort'
    },
  },

  methods: {
    handleSort(sortItem, sortOrderAsc) {
      this.sortItem = {
        sortField: sortItem.key,
        sortFieldName: sortItem.text,
        sortAsc: sortOrderAsc,
      }
      if (this.onSort) {
        this.onSort(this.sortItem)
      }
    },
  },
}
</script>

<style lang="scss">
.asc-sort-box-chart-button--container {
  .asc-sort-caption {
    font-size: 16px;
  }

  .asc-sort-box-chart-button {
    background-color: $accent-500;

    .v-btn {
      margin: 0;
      padding: 0;
      border: 1px solid $gray-400 !important;
      background-color: $primary-white !important;
      border-radius: 2px;
      text-transform: inherit;
      min-width: 56px;
      height: 32px;

      &:hover {
        background-color: $accent-100 !important;

        &::before {
          opacity: 0;
        }
      }

      .v-btn__content {
        color: $primary-black;
        font-size: $font-size-md;
        letter-spacing: 0;
        line-height: 18px;
        padding: 6px 9px;
        text-transform: uppercase;
      }
    }
  }
}

.asc-sort-box-chart-button--list-tile {
  min-height: 40px;
}

.asc-sort-box-chart-button--menu-list {
  .asc-sort-caption {
    cursor: default;
    user-select: none;
    text-transform: capitalize;
  }

  .asc-sort-action {
    width: 40%;
    margin: 0;

    .v-icon {
      &:hover {
        cursor: pointer;
        color: $primary-black !important;
      }

      &::after {
        background-color: $accent-400;
        border-radius: 0;
      }
    }
  }

  .v-list-item {
    &:hover {
      color: inherit;
      text-decoration: none;
    }
  }

  .v-list > div {
    background-color: $primary-white;
  }

  .v-list__tile--link {
    color: inherit;
    font-size: 14px;
  }

  .v-list {
    padding: 0;
    overflow-y: hidden;
  }

  .asc-descending-sort {
    margin-left: 8px;
  }
}
</style>
